import { FaGithub } from "react-icons/fa";
import ReactMarkdown from 'react-markdown';

const MarkdownText = ({ children }) => (
    <ReactMarkdown components={{
        p: ({ node, ...props }) => <span {...props} />,
        strong: ({ node, ...props }) => <strong className="font-bold" {...props} />,
        em: ({ node, ...props }) => <em className="italic" {...props} />,
    }}>
        {children}
    </ReactMarkdown>
);

const ExperienceHackathonCard = ({ experience, index }) => {
    return (
        <article className="group rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl dark:border-slate-700 dark:bg-slate-800 dark:hover:border-blue-900 sm:p-8">

            <h2 className="mb-2 text-2xl font-bold leading-tight text-slate-950 dark:text-white sm:text-3xl">
                {experience.workTitle}
            </h2>
            <div className="mb-6 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm sm:text-base">
                <a
                    href={experience.company.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-blue-700 transition-colors hover:text-blue-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600 dark:text-blue-300 dark:hover:text-blue-200 dark:focus-visible:outline-blue-300"
                >
                    {experience.company.name}
                </a>
                <span aria-hidden="true" className="text-slate-400 dark:text-slate-500">|</span>
                <span className="font-medium text-slate-700 dark:text-slate-300">{experience.project?.title}</span>
                <span aria-hidden="true" className="text-slate-400 dark:text-slate-500">|</span>
                <span className="text-slate-600 dark:text-slate-400">{experience.timeline}</span>
            </div>

            <div className="border-t border-slate-200 pt-5 dark:border-slate-700">
                {experience.challenge && (
                    <p className="mb-5 text-sm leading-relaxed text-slate-700 dark:text-slate-300 sm:text-base">
                        <MarkdownText>{experience.challenge}</MarkdownText>
                    </p>
                )}
                {experience.description && (
                    <p className="mb-6 text-sm leading-relaxed text-slate-700 dark:text-slate-300 sm:text-base">
                        <MarkdownText>{experience.description}</MarkdownText>
                    </p>
                )}

                <div className="mb-6 flex flex-wrap items-center gap-2">
                    {experience.techstack?.map((technology) => (
                        <span key={technology} className="rounded-md border border-slate-200 px-2.5 py-1 text-xs font-medium text-slate-600 dark:border-slate-600 dark:text-slate-300">
                            {technology}
                        </span>
                    ))}
                </div>
            </div>

            {experience.responsibilities?.length > 0 && (
                <section className="mb-7">
                    <h3 className="mb-4 text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                        Responsibilities
                    </h3>
                    <ul className="space-y-3 text-slate-700 dark:text-slate-300">
                        {experience.responsibilities.map((item, itemIndex) => (
                            <li key={itemIndex} className="flex items-start">
                                <span className="mr-3 mt-2 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-blue-600 dark:bg-blue-400" />
                                <span className="text-sm leading-relaxed sm:text-base"><MarkdownText>{item}</MarkdownText></span>
                            </li>
                        ))}
                    </ul>
                </section>
            )}

            {experience.outcome?.length > 0 && (
                <section className="mb-7">
                    <h3 className="mb-4 text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                        Outcome
                    </h3>
                    <ul className="space-y-3 text-slate-700 dark:text-slate-300">
                        {experience.outcome.map((item, itemIndex) => (
                            <li key={itemIndex} className="flex items-start">
                                <span className="mr-3 mt-2 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-blue-600 dark:bg-blue-400" />
                                <span className="text-sm leading-relaxed sm:text-base"><MarkdownText>{item}</MarkdownText></span>
                            </li>
                        ))}
                    </ul>
                </section>
            )}

            {experience.project?.repository_url && (
                <div className="border-t border-slate-200 pt-5 dark:border-slate-700">
                    <a
                        href={experience.project.repository_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 font-semibold text-blue-700 transition-colors hover:text-blue-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600 dark:text-blue-300 dark:hover:text-blue-200 dark:focus-visible:outline-blue-300"
                    >
                        <FaGithub className="text-lg" aria-hidden="true" />
                        GitHub Repository
                    </a>
                </div>
            )}
        </article>
    );
};

export default ExperienceHackathonCard;